/**
 *
 * @param {string} phone
 * @returns {boolean}
 */
export const validatePhone = (phone) => typeof phone === 'string' && /^\+380\d{9}$/.test(phone);
